import React from 'react';

import circleChecked from 'assets/icons/circle-check.svg';
import circleCrossed from 'assets/icons/circle-remove.svg';

// This should be a base util?
export const getBooleanIcon = (bool, trueAlt, falseAlt) => {
  return bool ? (
    <img src={circleChecked} alt={trueAlt} />
  ) : (
    <img src={circleCrossed} alt={falseAlt} />
  );
};
